export default __webpack_public_path__ + "static/media/instagram.912ab441.svg";